import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["modal", "form", "title", "score", "votesContainer"];

  open(event) {
    event.preventDefault();

    const projectId = event.currentTarget.dataset.projectId;
    const projectTitle = event.currentTarget.dataset.projectTitle;
    const projectScore = event.currentTarget.dataset.projectScore || "-";
    const template = document.getElementById(`jury-votes-template-${projectId}`);

    this.formTarget.action = `/campus/student_projects/${projectId}/approve_jury`;
    this.titleTarget.textContent = projectTitle;
    this.scoreTarget.textContent = projectScore;
    this.votesContainerTarget.innerHTML = "";

    if (template) {
      const content = template.content.cloneNode(true);
      this.votesContainerTarget.appendChild(content);
    }

    this.modalTarget.open();
  }

  close(event) {
    if (event) event.preventDefault();
    this.modalTarget.close();
  }
}
